module.exports = __webpack_public_path__ + "img/comment_1.ad9b6a8a.png";